import { MapTo } from '@adobe/aem-react-editable-components';
import LimitedEsignLetter, { LimitedEsignLetterEditConfig } from './LimitedEsignLetter';

export default MapTo('cob-corp-acquisition/components/creditonebank/limited-esign-letter')(LimitedEsignLetter, LimitedEsignLetterEditConfig);